import React, { useRef } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import Multiselect1 from 'multiselect-react-dropdown';
import { useTranslation } from 'react-i18next';
import { customStyles, shortenString } from '../../helper';

function FilterButton({
  detailList,
  onBtnClick,
  isDisable,
  isMultiSelectOption,
  multiSelectChange,
  isMultiSelectOptionGroup,
  active,
  module,
  otherFilters,
  onInputSearchChange,
}) {
  const triggerRef = useRef(null);
  const { t } = useTranslation('common');

  const containerRef = useRef(null);

  const selectName = (selected, arry) => {
    if (selected?.length === arry?.length) {
      return t('FILTER_BUTTON.ALL_ITEMS_SELECTED');
    }
    const arr = [];
    selected?.forEach((sel) => {
      arr.push(sel.name);
    });
    const strName = arr.join(',');
    return shortenString(strName, 20);
  };

  const valueRenderer = (selected, label) => {
    if (!selected?.length) {
      return label || t('FILTER_BUTTON.SELECT');
    }

    return selected?.length === 1 ? selected[0]?.label : selected?.map(({ label }) => `${label}, `);
  };
  const isSingleCol = (isMultiSelectOption?.length || 0) + (otherFilters?.length || 0) === 1;
  const optionValueDecorator = (v) => <span>{shortenString(v, 20)}</span>;

  return (
    <div ref={containerRef} className={`${isSingleCol ? 'single-col modified-popOver' : 'modified-popOver'}`}>
      <button
        type="button"
        className={`filter-btn  filter-button_add_colour_group ${active ? 'active' : ''}`}
        title={t('FILTER_BUTTON.FILTER')}
        // disabled={isDisable} // removed to give access to manupulate data if clicked outside
      >
        <OverlayTrigger
          placement={t('FILTER_BUTTON.BUTTON')}
          trigger="click"
          rootClose
          container={containerRef}
          target={triggerRef}
          overlay={
            <Popover className="custom-popover">
              <Popover.Content>
                <div className="filter-add-group-container flex-column">
                  <div className="row">
                    {detailList?.map((element, index) => {
                      return (
                        <div className="col-lg-6" key={index}>
                          <Select
                            isClearable
                            options={element?.option.map((e) => {
                              return {
                                name: e?.name || e?.label,
                                _id: e?._id || e?.value,
                              };
                            })}
                            getOptionLabel={(opt) => `${opt.name}`}
                            getOptionValue={(opt) => `${opt._id}`}
                            onChange={(e) => onBtnClick(`option_${index}_${element?.name}`, e)}
                            styles={customStyles}
                            value={element?.value}
                            placeholder={element?.placeholder}
                            noOptionsMessage={() => element?.noOption}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="row">
                    {isMultiSelectOption?.length > 0 &&
                      isMultiSelectOption?.map((element) => {
                        return (
                          <div className="col-lg-6 mb-1" key={element}>
                            <p className="mb-0">{element?.label}</p>
                            <MultiSelect
                              name="attributes"
                              options={element?.option}
                              className="custom-multiselect"
                              value={element?.value}
                              valueRenderer={(selected) => valueRenderer(selected, element?.label)}
                              labelledBy={t('FILTER_BUTTON.SELECT_ATTRIBUTES')}
                              onChange={(e) => multiSelectChange(e, element?.val)}
                            />
                          </div>
                        );
                      })}
                    {isMultiSelectOptionGroup?.length > 0 &&
                      isMultiSelectOptionGroup?.map((element) => {
                        return (
                          <div className="col-lg-6 mb-1" key={element}>
                            <Multiselect1
                              displayValue="name"
                              groupBy="groupName"
                              onSelect={(selected) => {
                                multiSelectChange(selected);
                              }}
                              className="custom-multiselect"
                              onRemove={(selected) => {
                                multiSelectChange(selected);
                              }}
                              placeholder={selectName(element?.value, element?.option)}
                              hideSelectedList
                              optionValueDecorator={optionValueDecorator}
                              options={element?.option}
                              showCheckbox
                              selectedValues={element?.value}
                              closeIcon="none"
                            />
                          </div>
                        );
                      })}
                    {module === 'duty' &&
                      otherFilters?.map((el) => {
                        return (
                          <div className="col-lg-6 mb-1" key={el}>
                            <div className="input-group form-floating-label fixed-label">
                              <input
                                type={el?.type}
                                value={el?.value}
                                onChange={(e) => onInputSearchChange(el?.val, e.target.value)}
                                className="form-control"
                              />
                              <label>{el?.placeholder}</label>
                            </div>
                          </div>
                        );
                      })}{' '}
                  </div>
                </div>
                {onBtnClick && (
                  <div className="filter-add-group-container mt-2 justify-content-end">
                    <button type="submit" onClick={() => onBtnClick()} id="Apply" className="btn btn-default" disabled={isDisable}>
                      {t('FILTER_BUTTON.APPLY')}
                    </button>
                    <button type="button" onClick={() => onBtnClick('clear')} id="Clear" className="btn btn-default ml-3" disabled={isDisable}>
                      {t('FILTER_BUTTON.CLEAR')}
                    </button>
                  </div>
                )}
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon-filter" />
        </OverlayTrigger>
        <span className="text-icon">{t('FILTER_BUTTON.FILTER')}</span>
      </button>
    </div>
  );
}

export default FilterButton;
